import React from 'react';

const Header = () => (
  <svg
    width="29"
    height="27"
    viewBox="0 0 29 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 9.33346H28V22.8255C28 24.5716 25.887 26.0001 23.3043 26.0001H5.69565C3.11304 26.0001 1 24.5716 1 22.8255V9.33346Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="3 3"
    />
    <path
      d="M1 9.33346H28"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M1 1H28V9.33333H1V1Z"
      stroke="#0F1C35"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M5.11141 6.35705C5.75975 6.35705 6.28533 5.82406 6.28533 5.16658C6.28533 4.50909 5.75975 3.9761 5.11141 3.9761C4.46308 3.9761 3.9375 4.50909 3.9375 5.16658C3.9375 5.82406 4.46308 6.35705 5.11141 6.35705Z"
      fill="#0F1C35"
    />
    <path
      d="M8.62704 6.35705C9.27537 6.35705 9.80095 5.82406 9.80095 5.16658C9.80095 4.50909 9.27537 3.9761 8.62704 3.9761C7.9787 3.9761 7.45312 4.50909 7.45312 5.16658C7.45312 5.82406 7.9787 6.35705 8.62704 6.35705Z"
      fill="#0F1C35"
    />
    <path
      d="M12.1505 6.35705C12.7988 6.35705 13.3244 5.82406 13.3244 5.16658C13.3244 4.50909 12.7988 3.9761 12.1505 3.9761C11.5021 3.9761 10.9766 4.50909 10.9766 5.16658C10.9766 5.82406 11.5021 6.35705 12.1505 6.35705Z"
      fill="#0F1C35"
    />
  </svg>
);

export default Header;
